import { render, staticRenderFns } from "./FasePage.vue?vue&type=template&id=bf743cdc"
import script from "./FasePage.js?vue&type=script&lang=js&external"
export * from "./FasePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports